export interface TextInputChangeEvent {
  value: string | number | undefined | null;
}
export interface SliderInputChangeEvent {
  value: number;
}

export interface CheckedInputChangeEvent extends TextInputChangeEvent {
  checked: boolean;
}

export interface InputChangeEvent {
  value: any;
}

export interface SelectInputChangeEvent {
  value: any | any[] | undefined | null;
  text: string | undefined | null;
}
